import React from 'react';

import withCard from './WithCard';
import Choice from '../../../Types/Components/Choice';

const ChoiceCard = (props) => {
  return <Choice {...props} />
}

export default withCard(ChoiceCard);